module.exports = "/assets/pattern-hero.png?3tqvpfy";